import styled, { css } from 'styled-components';

import { media } from 'utils/detection';

import ArrowButton from '../components/ArrowButton';

export default styled(ArrowButton)`
  display: none;

  ${media.medium`
    display: flex;
    transition-property: opacity, visibility;
    transition-duration: 0.3s;

    ${props => props.hidden && css`
      opacity: 0;
      visibility: hidden;
    `}
  `}
`;
